<template>
  <b-card title="Dosya Eki (İngilizce)">
    <div
      v-if="dataItem.filename_en"
      class="d-flex justify-content-center"
    >
      <div class="rounded height-auto text-center mb-2 p-2 border border-1 w-100">
        <div class="border border-1 p-1 rounded">
          Belge Yüklendi
        </div>
        <b-button
          class="mt-1"
          variant="secondary"
          size="sm"
          block
          :href="baseUrl + '/media/contents/' + dataItem.filename_en"
          target="_blank"
        >
          <FeatherIcon icon="DownloadIcon" />
          Görüntüle
        </b-button>
        <b-button
          block
          class="mt-1"
          variant="flat-danger"
          size="sm"
          @click="removeFile"
        >
          <FeatherIcon icon="TrashIcon" />
          Dosyayı Sil
        </b-button>
      </div>
    </div>
    <div
      v-else
      class="text-center mt-1"
    >
      <b-button
        variant="primary"
        @click="setModal"
      >
        <FeatherIcon icon="UploadIcon" />
        Dosya Yükle
      </b-button>
    </div>
    <docs-upload
      v-if="uploadSettings.modalStatus"
      :modal-status="uploadSettings.modalStatus"
      :close-modal="closeModal"
      :folder="uploadSettings.folder"
      component="contents"
      :item-id="dataItem.id"
      params="en"
      @uploadFile="setUploadFile"
    />
  </b-card>
</template>

<script>
import { BButton, BCard } from 'bootstrap-vue'
import DocsUpload from '@/layouts/components/common/DocsUpload.vue'

export default {
  name: 'FileCardTr',
  components: {
    BCard,
    BButton,
    DocsUpload,
  },
  props: {
    refreshData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      baseUrl: this.$store.state.app.baseURL,
      uploadSettings: {
        modalStatus: false,
        folder: null,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['contents/dataItem']
    },
  },
  methods: {
    setModal() {
      this.uploadSettings = {
        modalStatus: true,
        folder: 'contents',
      }
    },
    closeModal() {
      this.uploadSettings = {
        modalStatus: false,
        folder: null,
      }
    },
    removeFile() {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('fileUpload/removeData', this.dataItem.id_docs_en)
            .then(res => {
              if (res) {
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refreshData()
              }
            })
        }
      })
    },
    setUploadFile(item) {
      this.dataItem.filename_en = item.filename
      this.dataItem.filetype_en = item.filetype
      this.dataItem.fileData_en = item
      this.uploadSettings.modalStatus = false
    },
  },
}
</script>
